import axios from 'axios';

export class TagsService {
    async fetchAllTags(_data) {
        return (await axios.get('/tag/filter?status=Active', {params: _data})).data;
    }
}